export default __webpack_public_path__ + "static/media/user_activity_46_1.fab89724.svg";